var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenPlayButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#74B816"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30C14.4771 30 10 25.5228 10 20C10 14.4771 14.4771 10 20 10C25.5228 10 30 14.4771 30 20C30 25.5228 25.5228 30 20 30ZM20 28C24.4183 28 28 24.4183 28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 24.4183 15.5817 28 20 28ZM18.6219 16.4146L23.5008 19.6672C23.6846 19.7897 23.7343 20.0381 23.6117 20.2219C23.5824 20.2658 23.5447 20.3035 23.5008 20.3328L18.6219 23.5854C18.4381 23.708 18.1897 23.6583 18.0672 23.4745C18.0234 23.4088 18 23.3316 18 23.2526V16.7474C18 16.5265 18.1791 16.3474 18.4 16.3474C18.479 16.3474 18.5562 16.3708 18.6219 16.4146Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlayButton);
export default __webpack_public_path__ + "static/media/GreenPlayButton.a4138ab4391dc381565707423ae219b2.svg";
export { ForwardRef as ReactComponent };